export const styles = () => ({
  placeholder: {
    textAlign: 'center'
  }
})



// WEBPACK FOOTER //
// ./src/components/BigCalendar/styles.js